import { AnyAction } from 'redux';

import { myFleetActions } from '../reducer/reducer';
import { UserLocation } from 'entities/users';

export const setSelectedMobileLocation = (userLocation: UserLocation | null): AnyAction =>
  myFleetActions.setSelectedMobileLocation(userLocation);
